export function getColumnsCount(isCustomMobileView: boolean): 2 | 5 {
  return isCustomMobileView === true ||
    (typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(max-width: 599px)').matches)
    ? 2
    : 5;
}
